export const GROUP_BY_ENUM = {
    DAY: "DAY",
    MONTH: "MONTH",
    NONE: "NONE",
};
